<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <template v-if="user.tipo == 'Administrador'">
      <TituloComponent
      icono-titulo="fas fa-boxes"
      texto-titulo="Listado de artículos"
      :to-create-action="{name:'NuevoArticulo'}"
      to-create-text="Nuevo artículo"
      ></TituloComponent>
    </template>
    <template v-else>
      <TituloComponent
      icono-titulo="fas fa-boxes"
      texto-titulo="Listado de artículos"
      ></TituloComponent>
    </template>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 col-12 form-group input-group">
            <input
              type="text"
              id="search_data"
              class="form-control form-control-sm"
              placeholder="Buscar.."
              v-model="params.search"
              @keyup="search_query"
            />
            <span class="input-group-append">
              <button type="button" class="btn btn-sm btn-primary">
                <i class="fas fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <ul class="list-group list-group-flush mb-3" v-if="searching">
          <li class="list-group-item">
            <div class="skeleton">
              <div class="skeleton-author"></div>
              <div class="skeleton-content"></div>
              <div class="skeleton-content"></div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="skeleton">
              <div class="skeleton-author"></div>
              <div class="skeleton-content"></div>
              <div class="skeleton-content"></div>
            </div>
          </li>
        </ul>
        <ul class="list-group list-group-flush mb-3" v-else>
          <li
            class="list-group-item hoverable"
            v-for="articulo in articulos"
            :key="articulo.id"
            @click="acciones(articulo)"
          >
            <div class="widget-content p-0">
              <div class="widget-content-wrapper row">
                <div class="widget-content-left col-12">
                  <h5 class="widget-heading">{{articulo.codigo}} - {{articulo.descripcion}}</h5>
                  <div class="widget-subheading opacity-10 row">
                    <template v-if="user.tipo == 'Administrador'">
                      <span class="col-sm-auto col-6">
                        Compra:
                        <b class="text-success">${{articulo.precio_compra}}</b>
                      </span>
                      <span class="col-sm-auto col-6">
                      Precio:
                      <b class="text-success">${{articulo.precio_venta}}</b>
                    </span>
                    </template>
                    <span class="col-sm-auto col-6">
                      Precio final:
                      <b class="text-success">${{articulo.precio_final}}</b>
                    </span>
                    <span class="col-sm-auto col-6">
                      Stock:
                      <b
                        :class="(articulo.stock <= articulo.stock_minimo) ? 'text-danger' : '' "
                      >{{articulo.stock}}</b>
                    </span>
                    <template v-if="user.tipo == 'Administrador'">
                      <span class="col-sm-auto col-6">
                        Mínimo:
                        <b class>{{articulo.stock_minimo}}</b>
                      </span>
                    </template>
                    <span class="col-sm-auto col-12">
                      Marca:
                      <b class>{{articulo.marca.descripcion}}</b>
                    </span>
                    <span class="col-sm-auto col-12">
                      Familia:
                      <b class>{{articulo.familia.descripcion}}</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="row">
          <div class="col-12">
            <nav aria-label="...">
              <ul class="pagination justify-content-end pagination-sm">
                <li :class="['page-item', (current_page == 1) ? 'disabled': '']">
                  <button class="page-link" @click="prev_page()">
                    <i class="fas fa-angle-double-left"></i>
                  </button>
                </li>
                <li
                  :class="[(i == current_page) ? 'active': '', 'page-item']"
                  v-for="i in last_page"
                  :key="i"
                >
                  <button @click="goto_page(i)" class="page-link">{{i}}</button>
                </li>
                <li :class="['page-item', (current_page == last_page) ? 'disabled': '']">
                  <button class="page-link" @click="next_page()">
                    <i class="fas fa-angle-double-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "ListarProductos",
  components: {
    TituloComponent,
    BlockUI
  },
  data() {
    return {
      articulos: [],
      columns: [
        "Código",
        "Descripción",
        "Compra",
        "Venta",
        "Stock",
        "S. Mínimo",
        "Marca",
        "Familia",
        "IVA",
        ""
      ],
      loading: false,
      params: {
        search: "",
        paginate:true,
        page: 1
      },
      current_page: 1,
      last_page: null,
      searching: false
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    }),
  },
  mounted() {
    this.mounted = true;
    this.params.search = this.$route.query.search;
    this.getArticulos();
  },
  methods: {
    search_query: function(event) {
      clearTimeout(this.timer); 
      this.timer = setTimeout(() => {
        this.params.page = 1;
        if(this.params.search != event.target.value){
          this.params.search = event.target.value;
        }
        this.getArticulos();
        document.getElementById('search_data').focus()
      }, 1000)
    },
    getArticulos() {
      this.searching = true;
      axios
        .get("/articulos", { params: this.params })
        .then(res => {
          let response = res.data;
          this.current_page = response.current_page;
          this.last_page = response.last_page;
          let data = response.data;
          this.articulos = [];
          data.map(item => {
            this.articulos.push(item);
          });
          setTimeout(() => {
            this.buttons();
          }, 1);
          if (this.$route.query.search != this.params.search) {
            this.$router.replace({ query: { search: this.params.search } });
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.searching = false;
        });
    },
    eliminarArticulo(articulo) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${articulo.descripcion} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/articulos/" + articulo.id)
            .then(res => {
              Swal.fire(
                "Eliminado",
                `${res.data.articulo.descripcion} se ha eliminado con éxito.`,
                "success"
              );
              this.getArticulos();
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    },
    next_page() {
      if (this.current_page < this.last_page) {
        this.params.page++;
        this.current_page++;
      }
      this.getArticulos();
    },
    prev_page() {
      if (this.current_page > 1) {
        this.params.page--;
        this.current_page--;
      }
      this.getArticulos();
    },
    goto_page(i) {
      this.current_page = i;
      this.params.page = this.current_page;
      this.getArticulos();
    },
    buttons() {
      let tablas = document.querySelectorAll("table");
      for (let tabla of tablas) {
        let cabeceras = tabla.querySelectorAll("thead>tr>th");
        for (let cabecera of cabeceras) {
          if (cabecera.innerHTML == "") {
            let indexBotones = cabecera.cellIndex;
            let filas = tabla.querySelectorAll("tbody>tr");
            for (let fila of filas) {
              let columnaBotones = fila.childNodes[indexBotones];
              if (columnaBotones) {
                let cantidadBotones =
                  columnaBotones.querySelectorAll("button").length +
                  columnaBotones.querySelectorAll("a").length +
                  columnaBotones.querySelectorAll('input[type="checkbox"]')
                    .length;
                if (cantidadBotones > 0) {
                  columnaBotones.classList += " text-center";
                  let anchoColumna = parseFloat(cantidadBotones) * 38 + "px";
                  columnaBotones.style.width = anchoColumna;
                } else {
                  columnaBotones.style.display = "none";
                  cabecera.style.display = "none";
                }
              }
            }
          }
        }
      }
    },
    acciones(articulo) {
      if(this.user.tipo == "Administrador"){
        this.$router.push({
          name: "VerArticulo",
          params: {
            id: articulo.id
          }
        });
      }
    }
  }
};
</script>